import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  imagesLabel: {
    display: 'inline-block',
    marginBottom: '.313rem',
    textTransform: 'uppercase',
    fontSize: '.813rem',
    fontWeight: 'bold',
  },

  imagesHeader: {
    display: 'flex',
    marginBottom: '1rem',
    alignItems: 'center',
    borderBottom: '.0631rem solid #ddd',
    paddingBottom: '1rem',
  },

  selectedObservationsFeedback: {
    marginBottom: '0.9375rem',
  },

  tipBox: {
    marginTop: '1rem',
  },

  col: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  row: {
    display: 'flex',
    flex: 1,
  },

  form: {
    display: 'flex',
    flex: 1,
  },

  flexRow: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },

  flex1: {
    flex: 1,
  },
})

export default useStyles
